// hook/useManualServerSentEvents.ts
import { useCallback, useEffect, useState, useRef } from "react";
import { message } from "antd";

export interface CodeDataType {
  branch_name: string;
  repo_full_name: string;
  base_url: string;
}

export const useManualServerSentEvents = (
  url: string,
  setFlag: any,
  getInfo: any,
  resetFn: any,
  headers?: HeadersInit
) => {
  const [messages, setMessages] = useState({
    value: "",
    pending: false,
    uuid: "",
    userAskid: "",
    reasoning: "",
  });
  const [controller, setController] = useState<AbortController | null>(null);
  const [responseState, setResponseState] = useState<number>();
  const [isoutputing, setIsOutputing] = useState(false);
  const thinking_text = useRef("");
  const clearTag = useRef(true);
  const accumulatedContent = useRef("");
  const uuid = useRef("");
  const startFetching = useCallback(
    (data: any) => {
      const newController = new AbortController();
      setController(newController);
      const signal = newController.signal;
      // debugger
      const fetchData = async () => {
        try {
          setIsOutputing(true);
          const response: any = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...headers,
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify(data),
            signal,
          });
          // 记录请求返回状态
          setResponseState(Number(response.status));
          // debugger
          if (response.ok) {
            if (response.body) {
              const reader = response.body.getReader();
              const decoder = new TextDecoder();
              let accumulatedStr = "";
              let userAskid = "";
              accumulatedContent.current = "";
              thinking_text.current = "";
              while (true) {
                const res = await reader.read();
                const { done, value } = res;
                if (done) {
                  setMessages({
                    ...messages,
                    value: accumulatedContent.current,
                    pending: false,
                    uuid: uuid.current,
                    userAskid: userAskid,
                    reasoning: thinking_text.current,
                  });
                  clearTag.current = true; //清空上一次的内容
                  accumulatedContent.current = "";
                  thinking_text.current = "";
                  resetFn(true);
                  const ids = JSON.parse(
                    localStorage.getItem("threadIds") || "[]"
                  );
                  const newIds = ids.filter((item: any) => {
                    return item !== data.thread_id;
                  });
                  localStorage.setItem("threadIds", JSON.stringify(newIds));
                  setIsOutputing(false);
                  break;
                }
                accumulatedStr += decoder.decode(value, { stream: true });
                const lines = accumulatedStr.split("\nEND_OF_MESSAGE\n");
                accumulatedStr = lines.pop() || ""; // 保存最后的部分，如果是未完成的 JSON 对象
                for (const line of lines) {
                  if (line.trim() !== "") {
                    try {
                      const parsed = JSON.parse(line);
                      if (parsed.type === "answer") {
                        accumulatedContent.current += parsed.content;
                      } else if (parsed.type === "thought") {
                        thinking_text.current += parsed.content;
                      } else if (parsed.type === "error") {
                        accumulatedContent.current =
                          "对话出错，请刷新网页或者重建对话重试";
                      } else if (parsed.type === "message_uuid") {
                        uuid.current =
                          parsed.content?.message_response_uuid || "";
                        userAskid = parsed.content?.user_ask_uuid || "";
                      }
                    } catch (error) {
                      // console.error("Error parsing JSON:", error);
                    }
                  }
                }

                setMessages({
                  value: accumulatedContent.current,
                  pending: true,
                  uuid: uuid.current,
                  userAskid: userAskid,
                  reasoning: thinking_text.current,
                });
              }
              // 处理剩余的未完成的 JSON 对象
              if (accumulatedStr.trim() !== "") {
                try {
                  const parsed = JSON.parse(accumulatedStr);
                  console.log("Parsed remaining data:", parsed);
                  if (parsed.type === "message") {
                    setMessages((prevMessages: any) => {
                      return {
                        ...messages,
                        value: prevMessages + parsed.content,
                        pending: true,
                        uuid: uuid.current,
                      };
                    });
                  } else if (parsed.type === "error") {
                    resetFn(true);
                    message.error("对话出错，请刷新网页或者重建对话重试");
                    setMessages({
                      ...messages,
                      value: "对话出错，请刷新网页或者重建对话重试",
                      pending: false,
                      uuid: uuid.current,
                    });
                  } else if (parsed.code === 400) {
                    //对话不存在
                    resetFn(true);
                    message.error(parsed.message);
                    setMessages({
                      ...messages,
                      value: parsed.message,
                      pending: false,
                      uuid: uuid.current,
                    });
                  } else if (parsed.code === 402) {
                    //余额不足
                    getInfo();
                    resetFn(true);
                    // message.error(parsed.message);
                    setMessages({
                      ...messages,
                      value: parsed.message,
                      pending: false,
                      uuid: uuid.current,
                    });
                    setFlag(true);
                  } else if (parsed.code === 500) {
                    getInfo();
                    resetFn(true);
                    message.error(parsed.message);
                  }
                } catch (error) {
                  // console.error("Error parsing remaining JSON:", error);
                }
              }
            }
          } else {
            setMessages({
              ...messages,
              value: "对话出错，请刷新网页或者重建对话重试",
              pending: false,
              uuid: uuid.current,
            }); // 错误处理提示
            resetFn(true);
          }
        } catch (error: any) {
          if (error.name === "AbortError") {
            // Fetch was aborted
          } else {
            setMessages({
              ...messages,
              value: "对话出错，请刷新网页或者重建对话重试",
              pending: false,
              uuid: uuid.current,
            });
          }
          resetFn(true);
        }
      };

      fetchData();
    },
    [url, headers]
  );
  const stopFetching = useCallback(() => {
    if (controller) {
      controller.abort();
      setController(null);
    }
  }, [controller]);
  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (controller) {
        controller.abort();
      }
    };
  }, [controller]);

  return {
    messages,
    startFetching,
    stopFetching,
    responseState,
    isoutputing,
    setIsOutputing,
  };
};
